<template lang="pug">
    div
      el-main.cart()
        el-steps(id="Step", :active='step', finish-status='finish' , process-status='finish',  align-center, style="height: 180px;").cart__steps
          el-step(title='選擇寄件/收件方式')
          el-step(title='填寫寄件資訊')
          el-step(title='確認您的預約')
          el-step(title='完成預約')
        
        // el-main.cart()
        el-steps(id="verticalStep", :active='step', finish-status='finish' , process-status='finish', direction="vertical", align-center, style="height: 180px;").cart__steps
          el-step(title='選擇寄件/收件方式')
          el-step(title='填寫寄件資訊')
          el-step(title='確認您的預約')
          el-step(title='完成預約')
        router-view(@setStep='setStep', @keyInDetail='keyInDetail', :details='details', 
        @setCode='setCode', :code='code', 
        @setShippingMethod='setShippingMethod', :shippingMethod='shippingMethod',
        @setPbEcmap='setPbEcmap' :pbEcmap='pbEcmap' 
        @set_newCouponId='set_newCouponId' :newCouponId='newCouponId'
        @setUserLv='setUserLv' :Userlv='Userlv')
</template>
<!--
<style scoped>
.el-form-item .el-form-item__label{
    color: black;
}
body {
    margin: 0;
    background-color: #303030;
    background-image: url(https://ezwash.com.tw/wordpress/wp-content/uploads/2019/03/poly-1.png);
    background-size: cover;
    background-position: center bottom;
    background-attachment: scroll;
    background-repeat: repeat-x;
    color: white;
  }
  </style>-->
<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
export default {
  name: 'Cart',
  data () {
    return {
      step: 0,
      shippingMethod: 1,
      details: null,
      code: null,
      newCouponId: null,
      pbEcmap: {pb_ecmap_code: null,pb_ecmap_name: null, pb_ecmap_addr: null},
      Userlv: 0
    }
  },
  computed: {
    ...mapState('cart', ['cart'])
  },
  methods: {
    setStep (step) {
      this.step = step
    },
    keyInDetail (details) {
      console.log(details)
      this.details = details
    },
    setCode (code) {
      this.code = code
    },
    setShippingMethod (shippingMethod) {
      console.log(shippingMethod)
      this.shippingMethod = shippingMethod
      Cookies.set('shippingMethod', shippingMethod)
    },
    set_newCouponId (newCouponId) {
      console.log(newCouponId)
      this.newCouponId = newCouponId
    },
    setPbEcmap (pbEcmap) {
      this.pbEcmap = pbEcmap
    },
    setUserLv (Userlv) {
      this.Userlv = Userlv
    }
  },
  created() {
    let shippingMethod = Cookies.get('shippingMethod')
    console.log('shippingMethod', shippingMethod)
    if(!shippingMethod || shippingMethod == 'undefined' || shippingMethod == 'NaN' || shippingMethod == 'null'){
      this.shippingMethod = Number(1)
    }else{
      this.shippingMethod = Number(shippingMethod)
    }
    let phone = Cookies.get('phone');
    console.log("Cookies.get('phone')", phone)
    if(!phone){
      this.$router.replace({ name: 'LoginLndex' })
    }
  },
  mounted () {
    // this.$router.replace({ name: 'info' })
  }
}
</script>

<style lang="scss" scoped>
main {
  margin-top: 80px;
}
</style>


<style lang="scss" scoped>
#Step {
  display:none;
}
#verticalStep {
  display: flex;
}
@media (min-width: 600px){
  #Step {
    display: flex;
  }
  #verticalStep {
    display:none;
  }

  .el-main{
    padding: 0 12vw;
  }
  .cart__footer {
    width: 76vw;
  }
  
}

@media (min-width: 800px) {
  .el-main{
    padding: 0 20vw;
  }
  .cart__footer {
    width: 60vw;
  }

}
@media (min-width: 1000px){
  .el-main{
    padding: 0 calc(calc(100vw - 600px)/2);
  }
  .cart__footer {
    width: 60vw;
  }
}
// @media (min-width: 1000px) {
//   .el-main{
//     padding: 0 25vw;
//   }
//   .cart__footer {
//     width: 50vw;
//   }

// }

 
// .cart {
//   &__steps {
//     position: fixed;
//     width: calc(100vw - 40px);
//     background: white;
//     z-index: 99;
//     top: 40px;
//     padding-top: 12px;
//   }
// }
</style>
